import { useEffect } from 'react';

export function componentDidMount(callback, condition = []) {
  useEffect(() => {
    callback && callback();
  }, condition);
}